module.exports = __webpack_public_path__ + "static/media/calendar.0f1ce08e.svg";